// React Imports
import type { ImgHTMLAttributes } from 'react'

// Util Imports
import { cn } from '@/lib/utils'

/**
 * MAXIMUS-ИЙН ТЭМДЭГ.
 *
 * ! ФАЙЛААС УНШИНА, ИНЛАЙН SVG БИШ. Тэмдэг нь 15.8КБ — түүнийг JSX болгож
 * ! оруулбал энэ бүрдлийг импортолсон БҮХ багцад тэр хэмжээ шингэнэ
 * ! (нэвтрэх дэлгэц, зүүн цэсний ажлын талбарын тамга). `<img>` нь хөтчид
 * ! тусад нь кэшлэгдэж, нэг л удаа татагдана.
 *
 * ! ЗАГВАРААР ӨНГӨ СОЛИХГҮЙ. Лого нь брэндийн өнгөтэйгөө үлдэнэ — сэдэвт
 * ! дагаж өнгөө сольсон лого нь лого байхаа болино.
 *
 * ! Дуудагч хэмжээг өгнө (`size-8`); `aria-hidden` учир дэлгэц уншигчид
 * ! хажуугийн бичвэрийг л уншина.
 */
const Logo = ({ className, ...props }: ImgHTMLAttributes<HTMLImageElement>) => (
  <img
    src='/images/logo/maximus.svg'
    alt=''
    aria-hidden
    className={cn('shrink-0 object-contain', className)}
    {...props}
  />
)

export default Logo
